import { render } from "./EmptyEditor.vue?vue&type=template&id=ba40494a"
import script from "./EmptyEditor.vue?vue&type=script&lang=ts"
export * from "./EmptyEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script